import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchWebhookConfigurationBySetting,
  saveWebhookConfiguration as saveWebhookConfigurationApi,
} from "./webhookAPI";

export const getWebhookConfiguration = createAsyncThunk(
  "webhook/getConfiguration",
  async (settingId, thunkAPI) => {
    try {
      const data = await fetchWebhookConfigurationBySetting(settingId);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const saveWebhookConfiguration = createAsyncThunk(
  "webhook/saveConfiguration",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await saveWebhookConfigurationApi(payload);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const webhookSlice = createSlice({
  name: "webhook",

  initialState: {
    configuration: null,
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // GET CONFIGURATION
      .addCase(getWebhookConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getWebhookConfiguration.fulfilled, (state, action) => {
        state.configuration = action.payload;
        state.loading = false;
      })

      .addCase(getWebhookConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // SAVE CONFIGURATION
      .addCase(saveWebhookConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(saveWebhookConfiguration.fulfilled, (state, action) => {
        state.configuration = action.payload;
        state.loading = false;
      })

      .addCase(saveWebhookConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default webhookSlice.reducer;
